import React, { useMemo, useRef } from "react";

import TextFormatToolbar from "../../../../components/shared/textToolbar/TextFormatToolbar";
import { WATERMARK_ALIGN_CONFIG, WATERMARK_SPACING_CONFIG } from "../../../../components/shared/textToolbar/textFormatModel";

import { DEFAULT_WATERMARK_SETTINGS } from "./watermarkSettings";

import {

  getWatermarkTextFormatFonts,

  getWatermarkTextFormatTools,

  textFormatPatchToWatermark,

  watermarkToTextFormat,

} from "../Editor/watermarkTextFormatAdapter";

import "./WatermarkTextFormatToolbar.css";



/**

 * Universal watermark text toolbar — used on prep popup preview and editor canvas.

 */

const WatermarkTextFormatToolbar = ({

  watermark = null,

  onChange = () => {},

  visible = true,

  disabled = false,

  className = "watermark-text-format-toolbar",

  anchorSelector = ".watermark-text-format-toolbar",

  /** When true, merges { enabled: true } into each change (editor). */

  keepEnabled = false,

  /** Optional tool-id list; defaults to watermark text tool set. */
  tools: toolsOverride = null,

}) => {

  const settings = useMemo(

    () => ({

      ...DEFAULT_WATERMARK_SETTINGS,

      ...(watermark || {}),

    }),

    [watermark]

  );

  const settingsRef = useRef(settings);

  settingsRef.current = settings;



  const textFormatValue = useMemo(

    () => watermarkToTextFormat(settings),

    [settings]

  );



  const tools = useMemo(

    () =>

      Array.isArray(toolsOverride)

        ? toolsOverride

        : getWatermarkTextFormatTools(settings),

    [settings, toolsOverride]

  );

  const fonts = useMemo(() => getWatermarkTextFormatFonts(settings), [settings]);



  const handleChange = (next) => {

    const base = settingsRef.current;

    const { textCase, text: caseText, _meta, ...incoming } = next;

    const current = watermarkToTextFormat(base);

    const patch = {};

    for (const [key, val] of Object.entries(incoming)) {

      if (current[key] !== val) patch[key] = val;

    }

    let updated = textFormatPatchToWatermark(

      Object.keys(patch).length > 0 ? patch : incoming,

      base

    );

    if (textCase) {

      updated = textFormatPatchToWatermark(

        { textCase, text: base.text || "" },

        updated

      );

    }

    onChange(keepEnabled ? { ...updated, enabled: true } : updated);

  };



  if (!visible) return null;

  // Logo watermarks use ImageFormatToolbar instead.
  if (
    settings.contentType === "logo" &&
    Boolean(settings.logoUrl)
  ) {
    return null;
  }

  return (

    <div className={className} aria-live="polite">

      <TextFormatToolbar

        value={textFormatValue}

        onChange={handleChange}

        fonts={fonts}

        tools={tools}
        alignConfig={WATERMARK_ALIGN_CONFIG}
        spacingConfig={WATERMARK_SPACING_CONFIG}

        disabled={disabled}

        colorPickerAnchorSelector={anchorSelector}

        sizeConfig={{

          min: 0,

          max: 24,

          formatDisplay: (v) => String(Math.round(v * 10)),

          parseDisplay: (display) => Number(display) / 10,

        }}

      />

    </div>

  );

};



export default WatermarkTextFormatToolbar;


